import React from 'react'
import {NavLink,Outlet} from 'react-router-dom'
const Navbar= () => {
  return (
    <>
    <nav class="navbar navbar-dark  navbar-expand-lg bg-dark">
  <div class="container-fluid">
    <a class="navbar-brand" href="#">HUM FITNESS</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
      <div class="navbar-nav">
        <NavLink to="/" className ="nav-link">Home</NavLink>
        <NavLink to="/about"className="nav-link">About</NavLink>
        <NavLink to="/contact" className="nav-link" >Contact</NavLink>
       
      </div>
    </div>
  </div>
</nav>
  
    </>
  )
}

export default Navbar;